import { MoreOutlined } from "@ant-design/icons";
import { Button, Dropdown, Menu, Modal, Typography } from "antd";
import { default as React } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  ARCHIVE_MERCHANT,
  DASHBOARD_MERCHANT_ACTIONS,
  EDIT_SHIPPING_RULES,
  EDIT_ZONES,
  MANAGE_B2B_ADDRESSES,
  MANAGE_MERCHANT_USERS,
} from "../constants/merchants";
import "./ViewMerchants.css";

const CORE_RATES_GATED_ACTIONS = [EDIT_ZONES, EDIT_SHIPPING_RULES, MANAGE_B2B_ADDRESSES, ARCHIVE_MERCHANT];

const MerchantDashboardActions = ({ record, searchParam, handleArchiveMerchant }) => {
  const isUseCoreRatesFeatureFlag = useSelector((state) => state.featureFlag.useCoreRates);
  const dashboardActions = isUseCoreRatesFeatureFlag ? DASHBOARD_MERCHANT_ACTIONS : DASHBOARD_MERCHANT_ACTIONS;
  const confirmArchiveMerchant = (record) => {
    return Modal.confirm({
      title: `Are you sure you want to archive ${record.name}?`,
      content: `This action cannot be undone.`,
      onOk: (close) => handleArchiveMerchant(record.id),
    });
  };

  const renderMenuItem = (item, record) => {
    switch (item.key) {
      case EDIT_ZONES:
        return (
          <Link
            to={
              `/merchants/${encodeURIComponent(record.name)}/viewZones?merchantId=${record.id}` +
              (searchParam ? `&searchParam=${searchParam}` : "")
            }
          >
            {item.label}
          </Link>
        );
      case EDIT_SHIPPING_RULES:
        return (
          <Link
            to={
              `/merchants/${encodeURIComponent(record.name)}/viewShippingRules?merchantId=${record.id}` +
              (searchParam ? `&searchParam=${searchParam}` : "")
            }
          >
            {item.label}
          </Link>
        );
      case ARCHIVE_MERCHANT:
        return (
          <Typography.Text type="danger" onClick={() => confirmArchiveMerchant(record)}>
            {item.label}
          </Typography.Text>
        );
      case MANAGE_MERCHANT_USERS:
        return (
          <Link to={`/merchants/${record.id}/users` + (searchParam ? `&searchParam=${searchParam}` : "")}>
            {item.label}
          </Link>
        );
      case MANAGE_B2B_ADDRESSES:
        return (
          <Link
            to={{
              pathname: `/merchants/${record.id}/b2bAddresses`,
              search: searchParam ? `?searchParam=${searchParam}` : "",
              state: { merchant: record },
            }}
          >
            {item.label}
          </Link>
        );
      default:
        return null;
    }
  };

  const menuProps = (
    <Menu onClick={(e) => e.domEvent.stopPropagation()}>
      {dashboardActions.map((item) => (
        <Menu.Item key={item.key}>{renderMenuItem(item, record)}</Menu.Item>
      ))}
    </Menu>
  );

  return (
    <>
      <Dropdown overlay={menuProps}>
        <Button style={{ border: 0 }} onClick={(e) => e.stopPropagation()}>
          <MoreOutlined rotate={90} />
        </Button>
      </Dropdown>
    </>
  );
};

export default MerchantDashboardActions;
